<template>
    <v-dialog
    :value="show"
    persistent
    max-width="500px"
    @input="closeModal">
    <v-card >
      <v-card-title class="k-orange-linear mb-2">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="display-1">
              <h6>
                Editar cliente
              </h6>
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <scrollbar>
          <v-form ref="form" :lazy-validation="true" class="py-4">
            <v-layout row wrap class="text-xs-center k-grey-text">
              <v-flex xs12>
                <div class="subheader text-capitalize">
                  <v-text-field 
                    v-model="oldCustomer.name"
                    color="black"
                    label="Nombre y apellido"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="subheader text-capitalize">
                  <v-text-field 
                    v-model="oldCustomer.fiscal_id"
                    color="black"
                    label="RUT/DNI/CI"
                    data-vv-name="fiscal_id"
                    data-vv-as="RUT/DNI/CI"
                    :error-messages="errors.collect('fiscal_id')"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="subheader text-capitalize">
                  <v-text-field 
                    v-model="oldCustomer.account"
                    color="black"
                    label="Cuenta"
                    data-vv-name="account"
                    data-vv-as="Cuenta"
                    :error-messages="errors.collect('account')"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="subheader text-capitalize">
                  <v-select
                    :items="customerStatuses"
                    v-model="oldCustomer.customer_status_id"
                    item-text="status"
                    item-value="id"
                    label="Estado"
                    color="black"
                    data-vv-name="status_id"
                    data-vv-as="Estado"
                    :error-messages="errors.collect('status_id')"
                  ></v-select>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="subheader text-capitalize">
                  <v-select
                    :items="subStatuses"
                    v-model="oldCustomer.sub_status_id"
                    item-text="name"
                    item-value="id"
                    label="Sub-estado"
                    color="black"
                    data-vv-name="sub_status_id"
                    data-vv-as="Sub-estado del cliente"
                    :error-messages="errors.collect('sub_status_id')"
                  ></v-select>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </scrollbar>
      </v-card-text>
      <v-card-actions class="pr-2">
        <v-spacer></v-spacer>
        <v-btn color="black darken-1" flat @click="closeModal">
          Cerrar
        </v-btn>
        <v-btn  flat class="k-orange-linear-text" @click="save" :disabled="sending">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Scrollbar from 'vue-perfect-scrollbar';
import { mapGetters } from 'vuex';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
  },
  components: {
    Scrollbar,
  },
  mounted() {
    this.oldCustomer = {
      ...this.customer,
    };
  },
  data() {
    return {
      contact: {},
      sending: false,
      oldCustomer: {},
    };
  },
  computed: {
    nameContact() {
      return this.customer.name;
    },
    ...mapGetters([
      'customerStatuses',
      'subStatuses',
    ]),
  },
  methods: {
    save() {
      this.errors.clear();
      this.sending = true;
      this.axios.patch(`customers/${this.oldCustomer.id}`, {
        name: this.oldCustomer.name,
        account: this.oldCustomer.account,
        fiscal_id: this.oldCustomer.fiscal_id,
        customer_status_id: this.oldCustomer.customer_status_id,
        sub_status_id: this.oldCustomer.sub_status_id,
      }).then(() => {
        this.sending = false;
        const obj = {
          ...this.customer,
          ...this.oldCustomer,
        };
        this.$emit('customer-updated', obj);
        this.closeModal();
      }).catch(() => {
        this.customer = {
          ...this.customer,
          ...this.oldCustomer,
        };
        this.sending = false;
      });
    },
    closeModal() {
      this.$emit('close');
    },
  },
  watch: {
    customer: {
      immediate: true,
      handler: () => {
        this.oldCustomer = {
          ...this.customer,
        };
      },
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/customer/CustomerUpdate.vue